import { ReactElement } from "react";
import { useAppDispatch, useAppSelector } from "hooks/StoreHooks";
import ConnectionPage from "./ConnectionPage";
import { useEffect } from "react";
import { useGetTokenValidityQuery } from "services/api/connectionApi";
import {
  addLoadingRequest,
  removeLoadingRequest,
} from "store/Slices/appStateSlice";

interface ConnectionProps {
  children: ReactElement;
}

export default function Connection({ children }: ConnectionProps) {
  const dispatch = useAppDispatch();
  const token = useAppSelector(state => state.appState.token);
  const { isLoading, data } = useGetTokenValidityQuery(token);
  const canRead = useAppSelector(state => state.appState.d_inv22g.canRead);

  useEffect(() => {
    if (isLoading) {
      dispatch(addLoadingRequest("connection"));
    } else {
      dispatch(removeLoadingRequest("connection"));
    }
    return () => {
      dispatch(removeLoadingRequest("connection"));
    };
  }, [isLoading, dispatch]);

  if (isLoading) {
    return <p>Chargement....</p>;
  }

  return !token || !canRead || !data ? <ConnectionPage /> : children;
}
